import { useWsmDealerGroupCodesQuery } from "@dashboard/graphql";
import { mapEdgesToItems } from "@dashboard/utils/maps";

import { WsmTierGroup } from "./components/WsmOptionValuesCard/columns";

/**
 * The dealer groups the tier-delta columns are built from. A column keys on the
 * group's ID, because that is what a delta points at; the code rides along as
 * the label, because it is what a merchant and the storefront read.
 *
 * errorPolicy is "all" and a failure resolves to an empty list on purpose: a
 * question's retail choices have to stay editable on a backend with no dealer
 * groups in it. Empty means no dealer columns, never a broken screen.
 */
export const useTierGroups = (): WsmTierGroup[] => {
  const { data } = useWsmDealerGroupCodesQuery({
    variables: { first: 100 },
    errorPolicy: "all",
  });

  return (mapEdgesToItems(data?.wsmDealerGroups) ?? []).map(group => ({
    id: group.id,
    code: group.code,
    name: group.name,
  }));
};

export default useTierGroups;
